import { FileDto, useBackendApi } from 'nekst-api';

export interface SenderData {
  senderId: number;
  fullName: string;
  fromEmail: string;
  replyToEmail: string;
  emailSignature: string | null;
  primaryEmail: string;
  name: {
    fullName: string;
  };
  emailProvider: 'gmail' | null;
}

export interface EmailPreviewResponse {
  subject: string;
  preview: string;
  sender: SenderData;
  attachedFiles: FileDto[]
}

export function useEmailPreviewService() {
  const nekstApi = useBackendApi();

  const getEmailPreview = async (taskId: number) => {
    return await nekstApi.get(`/tasks/${taskId}/emailpreview`) as EmailPreviewResponse;
  };

  return {
    getEmailPreview,
  };
}
